import LocalizedStrings from 'localized-strings';

import { getMobileAppLang } from 'features/Accounting/pages/Estimation/common/utils';

export const locales = new LocalizedStrings(
  {
    en: {
      customRate: 'Withholding tax rates',
      description:
        'This is your personalized average tax rate, which you can find on:',
      payslip: 'a payslip',
      personalSpace: 'your personal space at ',
      subtitle: 'What is your withholding tax rate?',
      taxDeclaration: 'a tax notice',
      title: 'Customized rate',
    },
    fr: {
      customRate: 'Taux de prélèvement à la source',
      description:
        'Il s’agit de votre taux moyen d’imposition personnalisé, que vous pouvez retrouver sur :',
      payslip: 'une fiche de paie',
      personalSpace: 'votre espace personnel ',
      subtitle: 'Quel est votre taux de prélèvement à la source ?',
      taxDeclaration: 'un avis d’imposition',
      title: 'Taux personnalisé',
    },
  } as const,
  {
    customLanguageInterface: getMobileAppLang,
  },
);
